import React from 'react';
import Table from '../../components/common/Table';
import { QuickEventDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';
import createQuickEventActions from '../actionMenus/QuickEventActions';

interface QuickEventTableProps {
  data: QuickEventDTO[];
  handleView: (row: QuickEventDTO) => void;
  handleEdit: (row: QuickEventDTO) => void;
  handleDelete: (row: QuickEventDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const QuickEventTable: React.FC<QuickEventTableProps> = ({
  data,
  handleView,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Title',
          key: 'title',
        },
        {
          label: 'Province',
          key: 'provinceId',
          render: (row: QuickEventDTO) => (
            <span>{row.province?.title || 'Unknown'}</span>
          ),
        },
        {
          label: 'Town',
          key: 'town',
        },
        {
          label: 'Location',
          key: 'location',
        },
        {
          label: 'Date Start',
          key: 'dateStart',
          format: (value: Date | null) =>
            value ? convertToUserTime(value.toString()) : 'N/A',
        },
        {
          label: 'Date End',
          key: 'dateEnd',
          format: (value: Date | null) =>
            value ? convertToUserTime(value.toString()) : 'N/A',
        },
        {
          label: 'Active',
          key: 'isActive',
          render: (row: QuickEventDTO) =>
            renderBooleanBadge(row.isActive ?? false),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        extra: (row) =>
          createQuickEventActions({
            onViewRecord: handleView,
            onDelete: handleDelete,
          })(row),
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default QuickEventTable;
